// @ts-ignore
import $ from 'jquery';
export const initProSetting = (column) => {
    column.getElement().querySelectorAll('.ac-column-setting--pro').forEach(setting => {
        setting.querySelectorAll('input').forEach(input => {
            input.addEventListener('click', () => $(setting).find('[data-ac-modal]').trigger('click'));
        });
    });
};
